<template>
  <sh-table condensed="true">
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2">Solid Lines</sh-text></sh-table-cell
      >
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Primary</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="height: 4px; opacity: 0.7; background: #f7a71e"
          class="linesolid"
        ></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Secondary</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div style="opacity: 0.8; background: #39b54a" class="linesolid"></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Tertiary</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div style="opacity: 0.7; background: #672dca" class="linesolid"></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">PM</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div style="opacity: 0.7; background: #009999" class="linesolid"></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Trained</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="opacity: 0.7; height: 1px; background: #737373"
          class="linesolid"
        ></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2">Dashed Lines</sh-text></sh-table-cell
      >
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Primary not trained</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="opacity: 0.7; border-top: 4px dashed #f7a71e"
          class="linedashed"
        ></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Secondary not trained</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="opacity: 0.7; border-top: 2px dashed #39b54a"
          class="linedashed"
        ></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">Tertiary not trained</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="opacity: 0.7; border-top: 2px dashed #672dca"
          class="linedashed"
        ></div>
      </sh-table-cell>
    </sh-table-row>
    <sh-table-row>
      <sh-table-cell columns="8" style="text-align: left"
        ><sh-text size="body-2"></sh-text
      ></sh-table-cell>
      <sh-table-cell columns="12" style="text-align: left; white-space: nowrap"
        ><sh-text size="body-2">PM not trained</sh-text>
      </sh-table-cell>
      <sh-table-cell columns="4">
        <div
          style="opacity: 0.7; border-top: 2px dashed #009999"
          class="linedashed"
        ></div>
      </sh-table-cell>
    </sh-table-row>
  </sh-table>
</template>

<script>
export default {
  name: "MapLines",
  components: {},
  props: [],
  data() {
    return {};
  },
  mounted() {},
  created() {},
  beforeUnmount() {
    console.log("MapLines component destroyed!");
  },
  computed: {},
  methods: {},
  watch: {},
};
</script>

<style scoped lang="scss">
.linedashed {
  border: 0 none;
  margin-top: 50%;
  background: none;
  height: 0;
}

.linesolid {
  height: 2px;
  background: black;
  margin-top: 50%;
}
</style>
